<template>
  <v-card
    tile
    flat
    class="balanceCard"
    :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'"
  >
    <v-container>
      <v-row dense>
        <v-col cols="12">
          <v-sheet v-if="accountInfo"
            class="d-flex mb-0 justify-space-between align-center"
            :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'"
          >
            <div class="title">
              <v-icon dense color="#5F7692">mdi-bag-checked</v-icon>
              <span class="ml-2">My Account Balance</span>
              <p class="number mb-0 text--green">{{accountInfo.Balance}} <strong>USD</strong></p>
            </div>

            <div class="trade-dropdown">
              <v-menu
                rounded="0"
                class="trade-dropdown-menu"
                transition="slide-x-transition"
                bottom
                left
              >
                <template v-slot:activator="{ attrs, on }">
                  <v-btn
                    small
                    tile
                    elevation="0"
                    class="ma-0 text-capitalize btn-account"
                    v-bind="attrs"
                    v-on="on"
                    icon
                  >
                    <v-icon :color="$vuetify.theme.dark ? '#fff' : '#162334'"
                      >mdi-dots-vertical</v-icon
                    >
                  </v-btn>
                </template>
                <v-card class="dropdown-menu-card" tile flat>
                  <v-list
                    flat
                    outlined
                    :color="$vuetify.theme.dark ? '#111A26' : '#F1F7FB'"
                  >
                    <v-list-item-group>
                      <v-list-item
                        v-for="(item, i) in items"
                        :key="i"
                        :ripple="false"
                        link
                      >
                        <v-list-item-content>
                          <router-link
                            v-text="item.text"
                            class="text-decoration-none"
                            router
                            :to="item.link"
                          ></router-link>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-card>
              </v-menu>
            </div>
          </v-sheet>
          <v-skeleton-loader class="d-flex mb-0 justify-space-between align-center" v-if="!accountInfo" type="text" :loading="true" width="400"></v-skeleton-loader>
        </v-col>

        <v-col cols="12">
          <v-card-text class="d-flex pl-0 pb-2 mt-4 pr-0 trade align-center" v-if="accountInfo">
            <p class="equity">
              <span class="mb-2 d-inline-block">Acc. Type:</span> <strong>{{accountInfo.tradingaccounttypes.account_type_display}}</strong> <br />
              <span class="mb-2 d-inline-block">Credit:</span> <strong>${{accountInfo.Credit}}</strong> <br />
              <span class="mb-2 d-inline-block">Equity:</span> <strong>${{accountInfo.Equity}}</strong>
            </p>
            <v-spacer></v-spacer>
            <p class="equity text-right">
              <span class="mb-2 d-inline-block">Currency:</span> <strong>USD ($)</strong> <br />
              <span class="mb-2 d-inline-block">Leverage:</span> <strong>1 : {{accountInfo.leverage}}</strong> <br />
              <span class="mb-2 d-inline-block">Profit Share:</span> <strong>{{accountInfo.Profit}}%</strong>
            </p>
          </v-card-text>
          <v-skeleton-loader class="d-flex pl-0 pb-2 mt-4 pr-0 trade align-center" v-if="!accountInfo" type="text" :loading="true" width="400"></v-skeleton-loader>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { TRADEMASTER__ACTIONS } from "@/store/action-types";

export default {
  data() {
    return {
      items: [
        { text: "Deposit Funds", link: "/deposit" },
        { text: "Withdraw Funds", link: "/withdraw" },
        { text: "Internal Transfer", link: "/transfer-form" },
        { text: "Change Trading Password", link: "/" },
        { text: "Change Leverage", link: "/" },
        { text: "Account Detail", link: "/" },
      ],
    };
  },

  computed: {
    ...mapState("tradeMaster", ["accountDetails"]),

    accountInfo() {
      return this.accountDetails.liveAccounts
    }
  },

  methods: {
    ...mapActions("tradeMaster", [TRADEMASTER__ACTIONS.MT5ACCOUNTDETAILS])
  },
  async mounted() {
    await this[TRADEMASTER__ACTIONS.MT5ACCOUNTDETAILS](this.$route.params.id);
  },
};
</script>
